export default __webpack_public_path__ + "static/media/visibility-on-icon.eee5bdda.svg";